<template>
	<div class="pb-2">
	<v-row class="mt-4 pl-0 ml-n6 mb-3" style="margin-right: -2px;">
		<v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4" class="px-3 pt-0 pb-0">
								
			<v-row>
				<v-col cols="12" xs="12" sm="12" md="12" class="py-0 mx-3">
					<v-card width="100%" height="200" class="elevation-0 pl-4 pt-4" color="brighterBackground">
						<div class="body-2 font-weight-medium mb-n2">Key direction:</div>
						<v-radio-group v-model="field.typeProperties.relevantDirection" :mandatory="true" row>
							<v-radio color="blue darken-3" label="Vertical" value="vertical"></v-radio>
							<v-radio color="blue darken-3" label="Horizontal" value="horizontal"></v-radio>
						</v-radio-group>
					
						<div class="body-2 font-weight-medium mt-4 mb-2">Wrapping:</div>
						<v-radio-group v-model="field.typeProperties.wrap" :mandatory="true" row class="mt-1">
							<v-radio color="blue darken-3" class="mr-2" label="None" value="none"></v-radio>
							<v-radio color="blue darken-3" class="mr-2" label="Mobile" value="mobile"></v-radio>
							<v-radio color="blue darken-3" label="All" value="all"></v-radio>
						</v-radio-group>
					</v-card>
				</v-col>
				
			</v-row>
		</v-col>

		<v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4" class="px-3 pt-0 pb-0">
								
			<v-row>
				<v-col cols="12" xs="12" sm="12" md="12" class="py-0 mx-3">
					<v-card width="100%" height="200" class="elevation-0" color="brighterBackground">

						<div class="d-flex flex-row">
							<v-text-field
								class="mx-4 pt-4 ai-align-right"
								:label="(field.typeProperties.relevantDirection === 'vertical') ? 'Number of columns' : 'Number of rows'"
								v-model.number="field.typeProperties.rowOrCols"
								:rules="agile.fieldRules.integerRule"
								outlined
								readonly
								dense
							></v-text-field>
							<v-btn icon @click="decrementRowCols" class="ml-n3 mt-4">
								<v-icon>mdi-minus-circle</v-icon>
							</v-btn>
							<v-btn icon @click="incrementRowCols" class="ml-n1 mr-1 mt-4">
								<v-icon>mdi-plus-circle</v-icon>
							</v-btn>
						</div>

						<v-text-field
							class="mx-4 mt-n3 mb-n1"
							label="Custom styling CSS class"
							v-model="field.typeProperties.stylingClass"
							outlined
							dense
						></v-text-field>
					
						<v-checkbox
							cols="12" xs="12" sm="12" md="3"
							class="mx-3 pt-0 mt-n3 mt-0"
							label="Fullscreen as table"
							v-model="field.typeProperties.fullScreenAsCompleteTable"
						></v-checkbox>
					
						<v-checkbox
							ref="exposeToEditor"
							cols="12" xs="12" sm="12" md="3"
							class="mx-3 pt-0 mt-n2"
							label="Expose settings to editor"
							v-model="field.typeProperties.showInEditor"
						></v-checkbox>
					</v-card>
				</v-col>
				
			</v-row>
		</v-col>

		<v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4" class="px-3 pt-0 pb-0">
								
			<v-row>
				<v-col cols="12" xs="12" sm="12" md="12" class="py-0 mx-3">
					<v-card width="100%" height="200" class="elevation-0 pl-4 pt-5" color="brighterBackground">
						<v-checkbox
							cols="12" xs="12" sm="12" md="3"
							class="mx-3 pt-2 mt-0"
							label="Top row emphasis"
							v-model="field.typeProperties.topRowEmphasis"
						></v-checkbox>
						<v-checkbox
							cols="12" xs="12" sm="12" md="3"
							class="mx-3 pt-0 mt-n2 mt-0"
							label="End row emphasis"
							v-model="field.typeProperties.endRowEmphasis"
						></v-checkbox>
						<v-checkbox
							cols="12" xs="12" sm="12" md="3"
							class="mx-3 pt-0 mt-n2"
							label="Start column emphasis"
							v-model="field.typeProperties.startColEmphasis"
						></v-checkbox>
						<v-checkbox
							cols="12" xs="12" sm="12" md="3"
							class="mx-3 pt-0 mt-n2"
							label="End column emphasis"
							v-model="field.typeProperties.endColEmphasis"
						></v-checkbox>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
			
	</v-row>
	</div>
	
</template>


<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";


export default
{
    name: 'ViewTableField',

	props:
	{
		id: { type: String },
		field: { type: Object },
	},
	
    data: () =>
    ({
		
    }),



    computed:
	{
        agile()
        {
            return agile;
		},
		
		routeKey()
		{
			return this.$route.params.key;
		},
	},



	created()
	{
		
	},

    mounted()
    {
        
    },

    methods:
    {
		incrementRowCols()
		{
			this.field.typeProperties.rowOrCols = parseInt(this.field.typeProperties.rowOrCols)+1;
		},

		decrementRowCols()
		{
			this.$root.$confirm('Careful', 'Removing a table row/colum may result in data loss if you are not careful. Proceed?')
			.then((confirm) =>
			{
				if (confirm)
				{
					this.field.typeProperties.rowOrCols = parseInt(this.field.typeProperties.rowOrCols)-1;
				}
			});
			
		},
    }

}

</script>
